import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
import type { WidgetInfo } from '@/lib/widget-info';
import { InfoButton } from './InfoButton';

interface WidgetHeaderProps {
  /** 30px ikon (navy strokes) eller avatar — rendres til venstre for tittelen. */
  icon?: ReactNode;
  title: string;
  /** 14px #8A97A3-linje under tittelen. */
  subtitle?: ReactNode;
  /** «Om tallene»-innhold. Gir en (i)-knapp etter tittelen. */
  info?: WidgetInfo;
  /** Høyre slot: SegmentedPill, KPI, oppsummeringstekst e.l. */
  right?: ReactNode;
  className?: string;
}

/**
 * Felles header-anatomi for alle Måltall-widgets (VIB-1331):
 * ikon + tittel (Clash Display 24px, tracking −0.01em) + undertittel
 * (14px #8A97A3) + valgfri høyre-slot. Samme marger overalt (mb-6).
 */
export function WidgetHeader({ icon, title, subtitle, info, right, className }: WidgetHeaderProps) {
  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-x-6 gap-y-3 mb-6', className)}>
      <div className="flex items-center gap-3 min-w-0">
        {icon && <span className="shrink-0 flex items-center">{icon}</span>}
        <div className="min-w-0">
          <p className="font-display font-semibold text-[24px] text-[#081F3B] tracking-[-0.01em] leading-tight">
            {title}
            {info && <InfoButton name={title} info={info} className="ml-2 relative -top-0.5 align-middle" />}
          </p>
          {subtitle && <p className="text-[14px] text-[#8A97A3] mt-1">{subtitle}</p>}
        </div>
      </div>
      {right && <div className="flex flex-wrap items-center gap-[22px] min-w-0">{right}</div>}
    </div>
  );
}
